import { NgModule } from '@angular/core';

import { NgxQuillEditorComponent } from './quill-editor.component';
export class QuillModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [NgxQuillEditorComponent],
  imports: [],
  exports: [NgxQuillEditorComponent],
  providers: [],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuillModule_tsickle_Closure_declarations() {
/** @type {?} */
QuillModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuillModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
